"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "milano": {
    "udine-lambrate": [{
      "hkey": "3ef40a51",
      "slug": "lambrate",
      "name": "Lambrate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "92f5dd81": [{
      "hkey": "37760df9",
      "slug": "navigli-porta-genova",
      "name": "Navigli, Porta Genova",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "33b071b6",
      "slug": "solari-tortona-washington",
      "name": "Solari-Tortona, Washington",
      "primary": false,
      "skipSearch": false
    }],
    "centro-storico-brera": [{
      "hkey": "4bdf0e2d",
      "slug": "centro-duomo-brera",
      "name": "Centro, Duomo, Brera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "3a9a9977": [{
      "hkey": "8b46dfd9",
      "slug": "garibaldi-isola",
      "name": "Garibaldi, Isola",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "56bec251",
      "slug": "cenisio-sarpi",
      "name": "Cenisio, Sarpi",
      "primary": true,
      "skipSearch": false
    }],
    "6a94d625": [{
      "hkey": "71b86868",
      "slug": "affori-bovisa",
      "name": "Affori, Bovisa",
      "primary": true,
      "skipSearch": false
    }],
    "napoli-soderini": [{
      "hkey": "670b15d8",
      "slug": "bande-nere-inganni-lorenteggio",
      "name": "Bande Nere, Inganni, Lorenteggio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "acf59e2f": [{
      "hkey": "3ef40a51",
      "slug": "lambrate",
      "name": "Lambrate",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "ece08626",
      "slug": "adriano-crescenzago-parco-lambro-cimiano",
      "name": "Adriano, Crescenzago, Parco Lambro-Cimiano",
      "primary": false,
      "skipSearch": false
    }],
    "5457202b": [{
      "hkey": "670b15d8",
      "slug": "bande-nere-inganni-lorenteggio",
      "name": "Bande Nere, Inganni, Lorenteggio",
      "primary": true,
      "skipSearch": false
    }],
    "149d832d": [{
      "hkey": "85ba3e0b",
      "slug": "bicocca-ca-granda-parco-nord",
      "name": "Bicocca, Ca' Granda, Parco Nord",
      "primary": true,
      "skipSearch": false
    }],
    "bicocca-niguarda-ca-granda-parco-nord": [{
      "hkey": "85ba3e0b",
      "slug": "bicocca-ca-granda-parco-nord",
      "name": "Bicocca, Ca' Granda, Parco Nord",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d4b84d80": [{
      "hkey": "f5d3d07b",
      "slug": "citta-studi-corsica-susa",
      "name": "Città Studi, Corsica, Susa",
      "primary": true,
      "skipSearch": false
    }],
    "citta-studi-susa-corsica": [{
      "hkey": "f5d3d07b",
      "slug": "citta-studi-corsica-susa",
      "name": "Città Studi, Corsica, Susa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "694fbf25": [{
      "hkey": "91448154",
      "slug": "forlanini-mecenate-ponte-lambro",
      "name": "Forlanini, Mecenate, Ponte Lambro",
      "primary": true,
      "skipSearch": false
    }],
    "forlanini-parco-monlue-ponte-lambro": [{
      "hkey": "91448154",
      "slug": "forlanini-mecenate-ponte-lambro",
      "name": "Forlanini, Mecenate, Ponte Lambro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "15bba609": [{
      "hkey": "e4a6b323",
      "slug": "casoretto-nolo",
      "name": "Casoretto-NoLo",
      "primary": true,
      "skipSearch": false
    }],
    "loreto-nolo": [{
      "hkey": "e4a6b323",
      "slug": "casoretto-nolo",
      "name": "Casoretto-NoLo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c487e8e1": [{
      "hkey": "6c1ebc99",
      "slug": "san-siro-san-carlo",
      "name": "San Siro, San Carlo",
      "primary": true,
      "skipSearch": false
    }],
    "san-siro": [{
      "hkey": "6c1ebc99",
      "slug": "san-siro-san-carlo",
      "name": "San Siro, San Carlo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c3a67560": [{
      "hkey": "85f2448d",
      "slug": "bande-nere-gambara",
      "name": "Bande Nere-Gambara",
      "primary": true,
      "skipSearch": false
    }],
    "bande-nere": [{
      "hkey": "85f2448d",
      "slug": "bande-nere-gambara",
      "name": "Bande Nere-Gambara",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": null
    }],
    "3281858b": [{
      "hkey": "1838058b",
      "slug": "forze-armate-sella-nuova",
      "name": "Forze Armate-Sella Nuova",
      "primary": true,
      "skipSearch": false
    }],
    "forze-armate": [{
      "hkey": "1838058b",
      "slug": "forze-armate-sella-nuova",
      "name": "Forze Armate-Sella Nuova",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": "baggio-bisceglie-olmi"
    }],
    "bd9f176a": [{
      "hkey": "c62f0d54",
      "slug": "lorenteggio-giambellino",
      "name": "Lorenteggio-Giambellino",
      "primary": true,
      "skipSearch": false
    }],
    "giambellino": [{
      "hkey": "c62f0d54",
      "slug": "lorenteggio-giambellino",
      "name": "Lorenteggio-Giambellino",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": "bande-nere-inganni-lorenteggio"
    }],
    "6b641602": [{
      "hkey": "c62f0d54",
      "slug": "lorenteggio-giambellino",
      "name": "Lorenteggio-Giambellino",
      "primary": true,
      "skipSearch": false
    }],
    "lorenteggio": [{
      "hkey": "c62f0d54",
      "slug": "lorenteggio-giambellino",
      "name": "Lorenteggio-Giambellino",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": null
    }],
    "c7f64bea": [{
      "hkey": "ec902df5",
      "slug": "figino-quinto-romano",
      "name": "Figino, Quinto Romano",
      "primary": true,
      "skipSearch": false
    }],
    "parco-bosco-in-citta": [{
      "hkey": "ec902df5",
      "slug": "figino-quinto-romano",
      "name": "Figino, Quinto Romano",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "fe988d48": [{
      "hkey": "7af0f445",
      "slug": "quarto-cagnino",
      "name": "Quarto Cagnino",
      "primary": true,
      "skipSearch": false
    }],
    "quarto-cagnino": [{
      "hkey": "7af0f445",
      "slug": "quarto-cagnino",
      "name": "Quarto Cagnino",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": "san-siro-san-carlo"
    }],
    "40aaa816": [{
      "hkey": "f53c2d72",
      "slug": "casoretto",
      "name": "Casoretto",
      "primary": true,
      "skipSearch": false
    }],
    "loreto": [{
      "hkey": "f53c2d72",
      "slug": "casoretto",
      "name": "Casoretto",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": null
    }],
    "0f5f319b": [{
      "hkey": "a307587c",
      "slug": "nolo-parco-trotter",
      "name": "NoLo-Parco Trotter",
      "primary": true,
      "skipSearch": false
    }],
    "nolo": [{
      "hkey": "a307587c",
      "slug": "nolo-parco-trotter",
      "name": "NoLo-Parco Trotter",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": null
    }],
    "dde3bff0": [{
      "hkey": "a0187ff2",
      "slug": "cascina-merlata-cimitero-maggiore-viale-certosa",
      "name": "Cascina Merlata, Cimitero Maggiore, Viale Certosa",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "3a4f92f2",
      "slug": "gallaratese-qt8-trenno",
      "name": "Gallaratese, QT8, Trenno",
      "primary": true,
      "skipSearch": false
    }],
    "4804a5fb": [{
      "hkey": "a0187ff2",
      "slug": "cascina-merlata-cimitero-maggiore-viale-certosa",
      "name": "Cascina Merlata, Cimitero Maggiore, Viale Certosa",
      "primary": true,
      "skipSearch": false
    }],
    "maggiolina-istria": [{
      "hkey": "2e02944a",
      "slug": "dergano-maciachini-farini-maggiolina-zara",
      "name": "Dergano-Maciachini, Farini, Maggiolina-Zara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "viale-certosa-cascina-merlata": [{
      "hkey": "a0187ff2",
      "slug": "cascina-merlata-cimitero-maggiore-viale-certosa",
      "name": "Cascina Merlata, Cimitero Maggiore, Viale Certosa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "58a99b57": [{
      "hkey": "a0187ff2",
      "slug": "cascina-merlata-cimitero-maggiore-viale-certosa",
      "name": "Cascina Merlata, Cimitero Maggiore, Viale Certosa",
      "primary": true,
      "skipSearch": false
    }],
    "bocconi-c-so-italia-ticinese": [{
      "hkey": "37760df9",
      "slug": "navigli-porta-genova",
      "name": "Navigli, Porta Genova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "certosa-quarto-oggiaro-villa-pizzone": [{
      "hkey": "a0187ff2",
      "slug": "cascina-merlata-cimitero-maggiore-viale-certosa",
      "name": "Cascina Merlata, Cimitero Maggiore, Viale Certosa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "e973c322": [{
      "hkey": "bf09fd35",
      "slug": "guastalla-palestro",
      "name": "Guastalla, Palestro",
      "primary": true,
      "skipSearch": false
    }],
    "palestro-guastalla": [{
      "hkey": "bf09fd35",
      "slug": "guastalla-palestro",
      "name": "Guastalla, Palestro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "90c0b4a3": [{
      "hkey": "7c122e04",
      "slug": "muggiano",
      "name": "Muggiano",
      "primary": true,
      "skipSearch": false
    }],
    "parco-agricolo-sud": [{
      "hkey": "7c122e04",
      "slug": "muggiano",
      "name": "Muggiano",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": "baggio-bisceglie-olmi"
    }],
    "194c2997": [{
      "hkey": "3c0d8795",
      "slug": "cantalupa",
      "name": "Cantalupa",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "fb6c42fe",
      "slug": "ronchetto-sul-naviglio",
      "name": "Ronchetto sul Naviglio",
      "primary": false,
      "skipSearch": false
    }],
    "parco-dei-navigli": [{
      "hkey": "3c0d8795",
      "slug": "cantalupa",
      "name": "Cantalupa",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": "barona-famagosta-san-cristoforo"
    }],
    "0239511a": [{
      "hkey": "318d0045",
      "slug": "macconago-quintosole",
      "name": "Macconago, Quintosole",
      "primary": true,
      "skipSearch": false
    }],
    "parco-delle-abbazie": [{
      "hkey": "318d0045",
      "slug": "macconago-quintosole",
      "name": "Macconago, Quintosole",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "3080ec5a": [{
      "hkey": "e4bdd239",
      "slug": "abbiategrasso-chiesa-rossa-gratosoglio-ticinello",
      "name": "Abbiategrasso, Chiesa Rossa, Gratosoglio-Ticinello",
      "primary": true,
      "skipSearch": false
    }],
    "chiesa-rossa-cermenate-ripamonti": [{
      "hkey": "e4bdd239",
      "slug": "abbiategrasso-chiesa-rossa-gratosoglio-ticinello",
      "name": "Abbiategrasso, Chiesa Rossa, Gratosoglio-Ticinello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "8f0e4160": [{
      "hkey": "e4bdd239",
      "slug": "abbiategrasso-chiesa-rossa-gratosoglio-ticinello",
      "name": "Abbiategrasso, Chiesa Rossa, Gratosoglio-Ticinello",
      "primary": true,
      "skipSearch": false
    }],
    "abbiategrasso-chiesa-rossa": [{
      "hkey": "e4bdd239",
      "slug": "abbiategrasso-chiesa-rossa-gratosoglio-ticinello",
      "name": "Abbiategrasso, Chiesa Rossa, Gratosoglio-Ticinello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "c7dc6136": [{
      "hkey": "b0ca73c2",
      "slug": "arco-della-pace-sempione",
      "name": "Arco della Pace, Sempione",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "b8dccffe",
      "slug": "citylife-fiera-lotto-portello",
      "name": "CityLife, Fiera, Lotto, Portello",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "3a672d4a",
      "slug": "corso-magenta",
      "name": "Corso Magenta",
      "primary": false,
      "skipSearch": false
    }],
    "arco-della-pace-arena-pagano": [{
      "hkey": "b0ca73c2",
      "slug": "arco-della-pace-sempione",
      "name": "Arco della Pace, Sempione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "48fcc845": [{
      "hkey": "670b15d8",
      "slug": "bande-nere-inganni-lorenteggio",
      "name": "Bande Nere, Inganni, Lorenteggio",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "e4bdd239",
      "slug": "abbiategrasso-chiesa-rossa-gratosoglio-ticinello",
      "name": "Abbiategrasso, Chiesa Rossa, Gratosoglio-Ticinello",
      "primary": false,
      "skipSearch": false
    }],
    "76559a6b": [{
      "hkey": "670b15d8",
      "slug": "bande-nere-inganni-lorenteggio",
      "name": "Bande Nere, Inganni, Lorenteggio",
      "primary": true,
      "skipSearch": false
    }],
    "bande-nere-inganni": [{
      "hkey": "670b15d8",
      "slug": "bande-nere-inganni-lorenteggio",
      "name": "Bande Nere, Inganni, Lorenteggio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "fcbcae5a": [{
      "hkey": "71b86868",
      "slug": "affori-bovisa",
      "name": "Affori, Bovisa",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "85ba3e0b",
      "slug": "bicocca-ca-granda-parco-nord",
      "name": "Bicocca, Ca' Granda, Parco Nord",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "82c10d65",
      "slug": "gorla-greco-precotto",
      "name": "Gorla, Greco, Precotto",
      "primary": false,
      "skipSearch": false
    }],
    "bicocca-niguarda": [{
      "hkey": "85ba3e0b",
      "slug": "bicocca-ca-granda-parco-nord",
      "name": "Bicocca, Ca' Granda, Parco Nord",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5c237f15": [{
      "hkey": "dc9d29b8",
      "slug": "baggio-bisceglie-olmi",
      "name": "Baggio, Bisceglie, Olmi",
      "primary": true,
      "skipSearch": false
    }],
    "baggio-forze-armate-quinto-romano": [{
      "hkey": "dc9d29b8",
      "slug": "baggio-bisceglie-olmi",
      "name": "Baggio, Bisceglie, Olmi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "efe95a2d": [{
      "hkey": "dc9d29b8",
      "slug": "baggio-bisceglie-olmi",
      "name": "Baggio, Bisceglie, Olmi",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "670b15d8",
      "slug": "bande-nere-inganni-lorenteggio",
      "name": "Bande Nere, Inganni, Lorenteggio",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "ec902df5",
      "slug": "figino-quinto-romano",
      "name": "Figino, Quinto Romano",
      "primary": false,
      "skipSearch": false
    }],
    "bisceglie-baggio-olmi": [{
      "hkey": "dc9d29b8",
      "slug": "baggio-bisceglie-olmi",
      "name": "Baggio, Bisceglie, Olmi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "34273d99": [{
      "hkey": "56bec251",
      "slug": "cenisio-sarpi",
      "name": "Cenisio, Sarpi",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "b0ca73c2",
      "slug": "arco-della-pace-sempione",
      "name": "Arco della Pace, Sempione",
      "primary": true,
      "skipSearch": false
    }],
    "89cbc6d9": [{
      "hkey": "56bec251",
      "slug": "cenisio-sarpi",
      "name": "Cenisio, Sarpi",
      "primary": true,
      "skipSearch": false
    }],
    "garibaldi-isola-maciachini-monumentale": [{
      "hkey": "56bec251",
      "slug": "cenisio-sarpi",
      "name": "Cenisio, Sarpi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "cenisio-sarpi-isola": [{
      "hkey": "56bec251",
      "slug": "cenisio-sarpi",
      "name": "Cenisio, Sarpi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "cfa0d534": [{
      "hkey": "4bdf0e2d",
      "slug": "centro-duomo-brera",
      "name": "Centro, Duomo, Brera",
      "primary": true,
      "skipSearch": false
    }],
    "dea2089d": [{
      "hkey": "4bdf0e2d",
      "slug": "centro-duomo-brera",
      "name": "Centro, Duomo, Brera",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "3a672d4a",
      "slug": "corso-magenta",
      "name": "Corso Magenta",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "37760df9",
      "slug": "navigli-porta-genova",
      "name": "Navigli, Porta Genova",
      "primary": true,
      "skipSearch": false
    }],
    "5a011441": [{
      "hkey": "4bdf0e2d",
      "slug": "centro-duomo-brera",
      "name": "Centro, Duomo, Brera",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "4bdf0e2d",
      "slug": "centro-duomo-brera",
      "name": "Centro, Duomo, Brera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "fc497896": [{
      "hkey": "ece08626",
      "slug": "adriano-crescenzago-parco-lambro-cimiano",
      "name": "Adriano, Crescenzago, Parco Lambro-Cimiano",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "e4a6b323",
      "slug": "casoretto-nolo",
      "name": "Casoretto-NoLo",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "82c10d65",
      "slug": "gorla-greco-precotto",
      "name": "Gorla, Greco, Precotto",
      "primary": false,
      "skipSearch": false
    }],
    "greco-monza-palmanova-bicocca": [{
      "hkey": "ece08626",
      "slug": "adriano-crescenzago-parco-lambro-cimiano",
      "name": "Adriano, Crescenzago, Parco Lambro-Cimiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "8b1b7838": [{
      "hkey": "ece08626",
      "slug": "adriano-crescenzago-parco-lambro-cimiano",
      "name": "Adriano, Crescenzago, Parco Lambro-Cimiano",
      "primary": true,
      "skipSearch": false
    }],
    "cimiano-crescenzago-adriano": [{
      "hkey": "ece08626",
      "slug": "adriano-crescenzago-parco-lambro-cimiano",
      "name": "Adriano, Crescenzago, Parco Lambro-Cimiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "aa3dc24a": [{
      "hkey": "c91fa62d",
      "slug": "buenos-aires-porta-venezia",
      "name": "Buenos Aires, Porta Venezia",
      "primary": true,
      "skipSearch": false
    }],
    "df0c98c8": [{
      "hkey": "c91fa62d",
      "slug": "buenos-aires-porta-venezia",
      "name": "Buenos Aires, Porta Venezia",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "f5d3d07b",
      "slug": "citta-studi-corsica-susa",
      "name": "Città Studi, Corsica, Susa",
      "primary": true,
      "skipSearch": false
    }],
    "citta-studi-lambrate-udine-loreto": [{
      "hkey": "f5d3d07b",
      "slug": "citta-studi-corsica-susa",
      "name": "Città Studi, Corsica, Susa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "citta-studi-susa": [{
      "hkey": "f5d3d07b",
      "slug": "citta-studi-corsica-susa",
      "name": "Città Studi, Corsica, Susa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "176df785": [{
      "hkey": "b0ca73c2",
      "slug": "arco-della-pace-sempione",
      "name": "Arco della Pace, Sempione",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "b8dccffe",
      "slug": "citylife-fiera-lotto-portello",
      "name": "CityLife, Fiera, Lotto, Portello",
      "primary": true,
      "skipSearch": false
    }],
    "fiera-firenze-sempione-paolo-sarpi-arena": [{
      "hkey": "b8dccffe",
      "slug": "citylife-fiera-lotto-portello",
      "name": "CityLife, Fiera, Lotto, Portello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "city-life-fiera-sempione-portello": [{
      "hkey": "b8dccffe",
      "slug": "citylife-fiera-lotto-portello",
      "name": "CityLife, Fiera, Lotto, Portello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "75681531": [{
      "hkey": "6d6cce80",
      "slug": "ripamonti-vigentino",
      "name": "Ripamonti, Vigentino",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "91448154",
      "slug": "forlanini-mecenate-ponte-lambro",
      "name": "Forlanini, Mecenate, Ponte Lambro",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "dea87450",
      "slug": "corso-lodi-corvetto-rogoredo",
      "name": "Corso Lodi, Corvetto, Rogoredo",
      "primary": true,
      "skipSearch": false
    }],
    "ed8b4d53": [{
      "hkey": "6d6cce80",
      "slug": "ripamonti-vigentino",
      "name": "Ripamonti, Vigentino",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "dea87450",
      "slug": "corso-lodi-corvetto-rogoredo",
      "name": "Corso Lodi, Corvetto, Rogoredo",
      "primary": true,
      "skipSearch": false
    }],
    "forlanini-umbria-lodi-corvetto-rogoredo": [{
      "hkey": "dea87450",
      "slug": "corso-lodi-corvetto-rogoredo",
      "name": "Corso Lodi, Corvetto, Rogoredo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "corvetto-rogoredo": [{
      "hkey": "dea87450",
      "slug": "corso-lodi-corvetto-rogoredo",
      "name": "Corso Lodi, Corvetto, Rogoredo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "4be387f3": [{
      "hkey": "e4bdd239",
      "slug": "abbiategrasso-chiesa-rossa-gratosoglio-ticinello",
      "name": "Abbiategrasso, Chiesa Rossa, Gratosoglio-Ticinello",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "37687543",
      "slug": "barona-famagosta-san-cristoforo",
      "name": "Barona, Famagosta, San Cristoforo",
      "primary": true,
      "skipSearch": false
    }],
    "barona-giambellino-lorenteggio-famagosta-inganni": [{
      "hkey": "37687543",
      "slug": "barona-famagosta-san-cristoforo",
      "name": "Barona, Famagosta, San Cristoforo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "famagosta-barona": [{
      "hkey": "37687543",
      "slug": "barona-famagosta-san-cristoforo",
      "name": "Barona, Famagosta, San Cristoforo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "97f50fda": [{
      "hkey": "91448154",
      "slug": "forlanini-mecenate-ponte-lambro",
      "name": "Forlanini, Mecenate, Ponte Lambro",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "3ef40a51",
      "slug": "lambrate",
      "name": "Lambrate",
      "primary": false,
      "skipSearch": false
    }],
    "forlanini": [{
      "hkey": "91448154",
      "slug": "forlanini-mecenate-ponte-lambro",
      "name": "Forlanini, Mecenate, Ponte Lambro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "78bbb602": [{
      "hkey": "4bdf0e2d",
      "slug": "centro-duomo-brera",
      "name": "Centro, Duomo, Brera",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "8b46dfd9",
      "slug": "garibaldi-isola",
      "name": "Garibaldi, Isola",
      "primary": false,
      "skipSearch": false
    }],
    "garibaldi-moscova-porta-nuova": [{
      "hkey": "4bdf0e2d",
      "slug": "centro-duomo-brera",
      "name": "Centro, Duomo, Brera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "11aa8b75": [{
      "hkey": "3a672d4a",
      "slug": "corso-magenta",
      "name": "Corso Magenta",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "2f8c8dcf",
      "slug": "ticinese",
      "name": "Ticinese",
      "primary": true,
      "skipSearch": false
    }],
    "genova-ticinese": [{
      "hkey": "2f8c8dcf",
      "slug": "ticinese",
      "name": "Ticinese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "089b72bd": [{
      "hkey": "9b4fa6fc",
      "slug": "centrale-repubblica",
      "name": "Centrale, Repubblica",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "2e02944a",
      "slug": "dergano-maciachini-farini-maggiolina-zara",
      "name": "Dergano-Maciachini, Farini, Maggiolina-Zara",
      "primary": true,
      "skipSearch": false
    }],
    "p-ta-genova-romolo-solari": [{
      "hkey": "37760df9",
      "slug": "navigli-porta-genova",
      "name": "Navigli, Porta Genova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "9411e1ec": [{
      "hkey": "37760df9",
      "slug": "navigli-porta-genova",
      "name": "Navigli, Porta Genova",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "2f8c8dcf",
      "slug": "ticinese",
      "name": "Ticinese",
      "primary": false,
      "skipSearch": false
    }],
    "navigli": [{
      "hkey": "37760df9",
      "slug": "navigli-porta-genova",
      "name": "Navigli, Porta Genova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "1d3ca7fb": [{
      "hkey": "e4a6b323",
      "slug": "casoretto-nolo",
      "name": "Casoretto-NoLo",
      "primary": true,
      "skipSearch": false
    }],
    "nolo-pasteur-rovereto": [{
      "hkey": "e4a6b323",
      "slug": "casoretto-nolo",
      "name": "Casoretto-NoLo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "69309dd4": [{
      "hkey": "dea87450",
      "slug": "corso-lodi-corvetto-rogoredo",
      "name": "Corso Lodi, Corvetto, Rogoredo",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "91448154",
      "slug": "forlanini-mecenate-ponte-lambro",
      "name": "Forlanini, Mecenate, Ponte Lambro",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-lambro-santa-giulia": [{
      "hkey": "91448154",
      "slug": "forlanini-mecenate-ponte-lambro",
      "name": "Forlanini, Mecenate, Ponte Lambro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "754d2330": [{
      "hkey": "d8a9f8f5",
      "slug": "porta-romana-risorgimento",
      "name": "Porta Romana, Risorgimento",
      "primary": true,
      "skipSearch": false
    }],
    "v-giornate-xxii-marzo-porta-romana": [{
      "hkey": "d8a9f8f5",
      "slug": "porta-romana-risorgimento",
      "name": "Porta Romana, Risorgimento",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "e7bad9a4": [{
      "hkey": "d8a9f8f5",
      "slug": "porta-romana-risorgimento",
      "name": "Porta Romana, Risorgimento",
      "primary": true,
      "skipSearch": false
    }],
    "porta-romana-cadore-montenero": [{
      "hkey": "d8a9f8f5",
      "slug": "porta-romana-risorgimento",
      "name": "Porta Romana, Risorgimento",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "a126f388": [{
      "hkey": "c91fa62d",
      "slug": "buenos-aires-porta-venezia",
      "name": "Buenos Aires, Porta Venezia",
      "primary": true,
      "skipSearch": false
    }],
    "buenos-aires-indipendenza-p-ta-venezia": [{
      "hkey": "c91fa62d",
      "slug": "buenos-aires-porta-venezia",
      "name": "Buenos Aires, Porta Venezia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "d017f8f4": [{
      "hkey": "c91fa62d",
      "slug": "buenos-aires-porta-venezia",
      "name": "Buenos Aires, Porta Venezia",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "bf09fd35",
      "slug": "guastalla-palestro",
      "name": "Guastalla, Palestro",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "d8a9f8f5",
      "slug": "porta-romana-risorgimento",
      "name": "Porta Romana, Risorgimento",
      "primary": false,
      "skipSearch": false
    }],
    "porta-venezia-indipendenza": [{
      "hkey": "c91fa62d",
      "slug": "buenos-aires-porta-venezia",
      "name": "Buenos Aires, Porta Venezia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "22712546": [{
      "hkey": "dea87450",
      "slug": "corso-lodi-corvetto-rogoredo",
      "name": "Corso Lodi, Corvetto, Rogoredo",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "d9906d06",
      "slug": "porta-vittoria-molise",
      "name": "Porta Vittoria, Molise",
      "primary": true,
      "skipSearch": false
    }],
    "porta-vittoria-lodi": [{
      "hkey": "d9906d06",
      "slug": "porta-vittoria-molise",
      "name": "Porta Vittoria, Molise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "f4ac070b": [{
      "hkey": "82c10d65",
      "slug": "gorla-greco-precotto",
      "name": "Gorla, Greco, Precotto",
      "primary": true,
      "skipSearch": false
    }],
    "precotto-turro": [{
      "hkey": "82c10d65",
      "slug": "gorla-greco-precotto",
      "name": "Gorla, Greco, Precotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "e1dc0c8a": [{
      "hkey": "bf09fd35",
      "slug": "guastalla-palestro",
      "name": "Guastalla, Palestro",
      "primary": true,
      "skipSearch": false
    }],
    "quadronno-palestro-guastalla": [{
      "hkey": "bf09fd35",
      "slug": "guastalla-palestro",
      "name": "Guastalla, Palestro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "18115b9c": [{
      "hkey": "3a4f92f2",
      "slug": "gallaratese-qt8-trenno",
      "name": "Gallaratese, QT8, Trenno",
      "primary": true,
      "skipSearch": false
    }],
    "ed992e61": [{
      "hkey": "3a4f92f2",
      "slug": "gallaratese-qt8-trenno",
      "name": "Gallaratese, QT8, Trenno",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "6c1ebc99",
      "slug": "san-siro-san-carlo",
      "name": "San Siro, San Carlo",
      "primary": true,
      "skipSearch": false
    }],
    "bonola-molino-dorino-lampugnano": [{
      "hkey": "6c1ebc99",
      "slug": "san-siro-san-carlo",
      "name": "San Siro, San Carlo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "lotto-novara-s-siro-rembrandt": [{
      "hkey": "6c1ebc99",
      "slug": "san-siro-san-carlo",
      "name": "San Siro, San Carlo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "san-siro-trenno": [{
      "hkey": "6c1ebc99",
      "slug": "san-siro-san-carlo",
      "name": "San Siro, San Carlo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "00948b71": [{
      "hkey": "33b071b6",
      "slug": "solari-tortona-washington",
      "name": "Solari-Tortona, Washington",
      "primary": true,
      "skipSearch": false
    }],
    "de-angeli-vercelli-washington": [{
      "hkey": "33b071b6",
      "slug": "solari-tortona-washington",
      "name": "Solari-Tortona, Washington",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }],
    "10b47c29": [{
      "hkey": "33b071b6",
      "slug": "solari-tortona-washington",
      "name": "Solari-Tortona, Washington",
      "primary": true,
      "skipSearch": false
    }],
    "solari-washington": [{
      "hkey": "33b071b6",
      "slug": "solari-tortona-washington",
      "name": "Solari-Tortona, Washington",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "milano"
    }]
  }
};
exports["default"] = _default;